module.exports = __webpack_public_path__ + "static/img/wx_qrcode.27a45df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wx_qrcode.jpg
// module id = Q0/I
// module chunks = 10